<template>
  <div class="ui-counter">
    <v-btn class="ui-btn ui-counter_btn" :class="{ 'ui-counter_btn--disabled': value === min }" @click="decrement" :disabled="value === min"><v-icon>$outlineMinus</v-icon></v-btn>
    <div class="ui-counter_control">{{ value }}</div>
    <v-btn class="ui-btn ui-counter_btn" :class="{ 'ui-counter_btn--disabled': value === max }" @click="increment" :disabled="value === max"><v-icon>$outlinePlus</v-icon></v-btn>
  </div>
</template>

<script>
export default {
  name: 'UiCounter',

  props: {
    value: {
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: null,
    }
  },

  model: {
    prop: 'value',
    event: 'update',
  },

  methods: {
    decrement() {
      if(this.value === this.min) return
      this.$emit('update', this.value - 1)
    },

    increment() {
      if(this.value === this.max) return
      this.$emit('update', this.value + 1)
    }
  },
}
</script>

<style lang="sass">
.ui-counter
  display: flex
  align-items: center
  gap: p2e(4)

.ui-counter_btn
  width: p2e(40) !important
  min-width: initial !important
  height: p2e(40) !important
  min-height: initial !important
  border-radius: 50% !important
  background-color: $primary-color !important
  border: p2e(1) solid $primary-color !important
  color: #fff !important

  &.ui-counter_btn--disabled.theme--light.v-btn.v-btn--disabled.v-btn--has-bg
    background-color: #F5F5F5 !important
    border-color: rgb(230, 231, 234) !important
    color: #212121 !important

  .v-icon
    font-size: p2e(20) !important

.ui-counter_control
  width: p2e(40)
  text-align: center
</style>
